<script>
export default {
    computed: {
        members() {
            return this.$store.getters.members;
        },
        firstLetters() {
            if (this.members) {
                let firstLetters = [];
                this.members.forEach(m => {
                    var letter = m.companyName ? m.companyName.charAt(0) : null;
                    if (letter) {
                        firstLetters.push(letter);
                    }
                });
                return firstLetters.filter(
                    (value, index, array) => array.indexOf(value) === index
                );
            }
        }
    },
    methods: {
        companiesStartingWith(letter) {
            return this.members.filter(
                member => member.companyName ? member.companyName.charAt(0) == letter : false
            );
        }
    }
};
</script>

<template>
    <div class="wide membersGrouped mt-6">
        <div v-for="letter in firstLetters" class="leading-normal inline-block" :key="letter">
            <a
                v-if="companiesStartingWith(letter).length > 0"
                :href="`#${letter}`"
                class="btn btn-white btn-sm mr-2 mb-2 block"
            >{{ letter }}</a>
        </div>
    </div>
</template>
